import { Nullable } from 'cng-common/models/utils'

import { PARTNER_FLAG_WARNING_CONFIGS, PartnerFlagWarningConfig } from '../config/configs'

export const getPartnerFlagWarningConfig = (code?: string): Nullable<PartnerFlagWarningConfig> => {
  if (!code) {
    return null
  }

  const normalizedCode = code.trim().toLowerCase()

  return (
    PARTNER_FLAG_WARNING_CONFIGS.find((config) => {
      if (Array.isArray(config.codes)) {
        return config.codes.some((item) => item.trim().toLowerCase() === normalizedCode)
      }

      return config.codes.trim().toLowerCase() === normalizedCode
    }) ?? null
  )
}
